export const routes = {
    HOME: '/',
    FORGOT_PASSWORD: '/forgotPassword',
    RESET_PASSWORD: '/resetPassword/:token',
    SETTINGS: '/settings',
    RESTAURANTS: '/restaurants',

    //SUBMENU RESTAURANT
    RESTAURANT: '/restaurants/:id',
    RESTAURANT_P24_MERCHANTS: '/restaurants/:id/p24/merchants',
    RESTAURANT_P24_TRANSACTIONS: '/restaurants/:id/p24/transactions',
    RESTAURANT_P24_LOGS: '/restaurants/:id/p24/logs',

    NETWORKS: '/networks',
    USERS: '/users',
    CONNECTIONS: '/connections',
    // P24: '/p24',
    P24_TRANSACTIONS: '/p24/transactions',
    P24_TRANSACTION: '/p24/transactions/:id',
    P24_MERCHANTS: '/p24/merchants',
    P24_LOGS: '/p24/logs',
    LOGIN: '/login',
    _404: '/404'
};

//szczegoly pojedynczej restauracji
export const restaurantRouteBuilder = (id) => `/restaurants/${id}`;
//szczegoly platnosci p24 pojedynczej restauracji
export const restaurantP24TransactionRouteBuilder = (id) => `/restaurants/${id}/p24/transactions`;
//szczegoly merchantow p24 pojedynczej restauracji
export const restaurantP24MerchantRouteBuilder = (id) => `/restaurants/${id}/p24/merchants`;
//szczegoly logow p24 pojedynczej restauracji
export const restaurantP24LogRouteBuilder = (id) => `/restaurants/${id}/p24/logs`;
